import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-product-comercial',
  templateUrl: './custom-product-comercial.component.html',
  styleUrls: ['./custom-product-comercial.component.scss'],
  standalone: false
})
export class CustomProductComercialComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
